import type { FC } from 'react';

import { Icon, Root } from './styles';
import type { RemoveButtonProps } from './types';

export const RemoveButton: FC<RemoveButtonProps> = ({ 'data-testid': testId, onClick }) => (
  <Root
    color="default"
    variant="contained"
    data-testid={testId}
    onClick={onClick}
  >
    <Icon />
  </Root>
);
